import { HOTEL_FORM_STATE_TYPE } from '@/components/Hotels/types'
import React, { useState } from 'react'

export type SearchFormContextType<T = HOTEL_FORM_STATE_TYPE> = {
  updateFormValues: (formValues: any) => void
  formValues: T
}

export const SearchFormContext = React.createContext(
  {} as SearchFormContextType
)

function SearchFormProvider({
  children
}: {
  children: JSX.Element | JSX.Element[]
}) {
  const [formValues, updateFormValues] = useState({} as HOTEL_FORM_STATE_TYPE)

  return (
    // TODO: Potentially impacting performance. Should be investigated
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <SearchFormContext.Provider value={{ formValues, updateFormValues }}>
      {children}
    </SearchFormContext.Provider>
  )
}

export default SearchFormProvider
